import { runtimeConfig } from "@/shared/config/runtime-config-loader";

export const API_URL = runtimeConfig.apiUrl;

export const USER_PREFERENCES_BASE_URL = `${API_URL}/user_preferences`;
export const GROUPS_BASE_URL = `${API_URL}/groups`;
export const USERS_BASE_URL = `${API_URL}/users`;
export const DASHBOARD_BASE_URL = `${API_URL}/dashboard`;
export const INVITATION_URL = `${API_URL}/invitations`;
export const REGISTER_URL = `${API_URL}/register`;
export const CUSTOMERS_BASE_URL = `${API_URL}/customers`;
export const COMPONENTS_BASE_URL = `${API_URL}/components`;
export const USER_GRAPH_DATA_BASE_URL = `${API_URL}/dashboard/ursula/graph-data`;
